import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';
import {
  useRetailerNetworkLocationStatesQuery,
  useRetailerNetworkLocationCitiesQuery,
} from '@occc/graphql';

export const useGetRetailerNetworkLocationStates = (retailerNetworkUuid: string) => {
  const { data, loading } = useRetailerNetworkLocationStatesQuery({
    variables: { filter: { retailerNetworkUuidEquals: retailerNetworkUuid } },
    skip: !retailerNetworkUuid,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
  });
  return { states: data?.retailerNetworkLocationStates ?? [], loading };
};

export const useGetRetailerNetworkLocationCities = (retailerNetworkUuid: string, state: string) => {
  const { data, loading } = useRetailerNetworkLocationCitiesQuery({
    variables: { filter: { retailerNetworkUuidEquals: retailerNetworkUuid, stateEquals: state } },
    skip: !retailerNetworkUuid || !state,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
  });
  return { cities: data?.retailerNetworkLocationCities ?? [], loading };
};
